import { Grid2, Icon, RHFTextField } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { Typography } from '@mui/material';
import { memo } from 'react';
import { useFormContext } from 'react-hook-form';
import { useBulkFilterItemState } from '../../hooks/use-bulk-filter-item-state';
import * as SX from './sx';
import type { BulkInputFilterTextareaProps as Props } from './types';

export const BulkInputFilterTextarea = memo(
  ({
    className,
    defaultValue,
    onChange,
    invalidItemsCount,
    ...filter
  }: Props) => {
    const methods = useFormContext();
    methods.watch();
    const values = methods.getValues();
    const { count, limit } = useBulkFilterItemState(
      filter.field!,
      filter.metadata,
      values
    );

    onChange?.(methods.formState.isDirty, values);

    return (
      <Grid2
        container
        className={classnames('BulkInputFilterTextarea', className)}
        sx={SX.root}
        gap={0.5}
      >
        <Grid2 container xs={12}>
          <Grid2 xs={12} columnGap={0.5} alignItems="center">
            <Typography
              variant="body2"
              color="black"
              fontWeight={700}
              children={filter.name}
            />
            <Typography variant="body3" children={`(${count}/${limit})`} />
            {!!filter.icon && (
              <Icon
                name={filter.icon}
                color={(p) => p.palette.error[800]}
                size={12}
              />
            )}
          </Grid2>
          <Grid2 justifyContent="space-between" xs={12}>
            <Typography
              variant="body4"
              color="grey.500"
              children={filter.metadata?.info}
            />
          </Grid2>
        </Grid2>
        <Grid2
          xs={12}
          container
          justifyContent="space-between"
          paddingTop={0.5}
        >
          <Typography
            variant="body5"
            color="grey.500"
            fontWeight={500}
            children={`Paste ${filter.metadata?.dialog?.subTitleItemLabel}  (one per line)`}
          />
          <Typography
            variant="body5"
            color="grey.500"
            children={`Max: ${limit} ${filter.metadata?.dialog?.subTitleItemLabel}`}
          />
        </Grid2>
        <Grid2 xs={12}>
          <RHFTextField
            error={!!invalidItemsCount}
            name={filter.field!}
            multiline
            minRows={5}
            maxRows={6}
            placeholder={filter.metadata?.dialog?.textArea?.placeholder}
            InputProps={{ sx: SX.input }}
          />
        </Grid2>
      </Grid2>
    );
  }
);

BulkInputFilterTextarea.displayName = 'BulkInputFilterTextarea';
